<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               width="500px">
      <div>
        <el-input type="textarea"
                  autosize
                  class="custon-textarea"
                  placeholder="请输入内容"
                  v-model="textarea">
        </el-input>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sendMessage } from '@/api/senior'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    greetingType: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      detail: this.content,
      title: '打招呼语',
      textarea: '',
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.detail = val
    },
  },
  methods: {
    handleClose() {
      this.textarea = ''
      this.$emit('close')
    },
    open() {
      // console.log('打开')
    },
    handleSubmit() {
      if (this.greetingType == 1) {
        sendMessage({
          target_user_type: this.detail.point_a_user_type,
          target_user_id: this.detail.point_a_user_id,
          message: this.textarea,
        }).then((res) => {
          if (res != '暂仅支持学生参与的聊天') {
            this.$message.success(`操作成功`)
             this.$emit("commcateSubmit")
            this.$emit('close')
          }
        })
      } else {
        sendMessage({
          target_user_type: this.detail.sender_user_type,
          target_user_id: this.detail.sender_user_id,
          message: this.textarea,
        }).then((res) => {
          console.log('resgh', res)
          if (res != '暂仅支持学生参与的聊天') {
            this.$message.success(`操作成功`)
             this.$emit("listSubmit")
            this.$emit('close')
           
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
::v-deep .custon-textarea .el-textarea__inner {
  min-height: 100px !important;
}
.dialog-wrap {
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
/deep/.el-upload {
  width: 122px;
  height: 122px;
  line-height: 122px;
}
/deep/.el-upload-list__item {
  width: 122px;
  height: 122px;
}
</style>
